import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export default function AuthLoginModal({ isOpen, onClose, onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);
        try {
            await onLogin('user', { username, password });
            setUsername('');
            setPassword('');
        } catch (err) {
            setError(err.message || 'Invalid credentials. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setUsername('');
        setPassword('');
        setError(null);
        onClose();
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div
                        className="auth-modal-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        onClick={handleClose}
                    />
                    <motion.div
                        className="auth-modal"
                        initial={{ opacity: 0, scale: 0.97, x: '-50%', y: 'calc(-50% + 16px)' }}
                        animate={{ opacity: 1, scale: 1, x: '-50%', y: '-50%' }}
                        exit={{ opacity: 0, scale: 0.97, x: '-50%', y: 'calc(-50% + 16px)' }}
                        transition={{ duration: 0.25, ease: 'easeOut' }}
                    >
                        <div className="auth-modal-accent-bar" />
                        <div className="auth-modal-body">
                            <button
                                className="auth-modal-close"
                                onClick={handleClose}
                                aria-label="Close"
                            >
                                ✕
                            </button>
                            <h2 className="auth-modal-title">Sign in</h2>
                            <p className="auth-modal-sub">
                                Access the full collection — drafts, manuscripts, and works in progress.
                            </p>
                            <form onSubmit={handleSubmit}>
                                <div className="auth-form-field">
                                    <label className="auth-form-label">Username</label>
                                    <input
                                        type="text"
                                        className="auth-form-input"
                                        value={username}
                                        onChange={e => setUsername(e.target.value)}
                                        required
                                        autoFocus
                                        placeholder="Enter your username"
                                        autoComplete="username"
                                    />
                                </div>
                                <div className="auth-form-field">
                                    <label className="auth-form-label">Password</label>
                                    <input
                                        type="password"
                                        className="auth-form-input"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        required
                                        placeholder="Enter your password"
                                        autoComplete="current-password"
                                    />
                                </div>
                                {error && <p className="auth-error">{error}</p>}
                                <button
                                    type="submit"
                                    className="auth-submit-btn"
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Signing in…' : 'Sign in'}
                                </button>
                            </form>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}
